import { render, staticRenderFns } from "./TabComplainHistory.vue?vue&type=template&id=512d8b34&"
import script from "./TabComplainHistory.vue?vue&type=script&lang=js&"
export * from "./TabComplainHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports